export const UserNullIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="12" fill="#D5DEFF" />
    <path
      d="M16.6666 17.25V16.0833C16.6666 15.4645 16.4208 14.871 15.9832 14.4334C15.5456 13.9958 14.9522 13.75 14.3333 13.75H9.66665C9.04781 13.75 8.45432 13.9958 8.01673 14.4334C7.57915 14.871 7.33331 15.4645 7.33331 16.0833V17.25M14.3333 9.08333C14.3333 10.372 13.2886 11.4167 12 11.4167C10.7113 11.4167 9.66665 10.372 9.66665 9.08333C9.66665 7.79467 10.7113 6.75 12 6.75C13.2886 6.75 14.3333 7.79467 14.3333 9.08333Z"
      stroke="#2D5BFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
